import { MapControl, withLeaflet } from "react-leaflet";
import { connect } from "react-redux";
import L from "leaflet";
import "./leaflet-ruler.scss";
import "./leaflet-ruler";

class LeafletRuler extends MapControl {
  _controlAdded = false;

  createLeafletElement(props) {
    return L.control.ruler({
      lengthUnit: {
        factor: 1,
        display: "m",
        decimal: 3,
        label: "Distance:",
      },
      ...props,
    });
  }

  addRulerToMap() {
    const { map } = this.props.leaflet;
    if (!map || !this.leafletElement || this._controlAdded) return;
    this.leafletElement.addTo(map);
    this._controlAdded = true;
    const container = this.leafletElement.getContainer();
    if (container) {
      const { style } = this.props;
      if (style) {
        Object.assign(container.style, style);
      }
      container.classList.add("ruler-button-hidden");
      this._deferredStart = setTimeout(() => {
        container.click();
      }, 0);
    }
  }

  removeRulerFromMap() {
    if (!this._controlAdded) return;
    if (this._deferredStart) {
      clearTimeout(this._deferredStart);
      this._deferredStart = null;
    }
    const { map } = this.props.leaflet;
    if (map && this.leafletElement) {
      if (this.leafletElement._choice) {
        this.leafletElement._toggleMeasure();
      }
      map.removeControl(this.leafletElement);
    }
    this._controlAdded = false;
  }

  componentDidMount() {
    if (this.props.rulerVisibility) {
      this.addRulerToMap();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rulerVisibility !== this.props.rulerVisibility) {
      if (this.props.rulerVisibility) {
        this.addRulerToMap();
      } else {
        this.removeRulerFromMap();
      }
    }
  }

  componentWillUnmount() {
    this.removeRulerFromMap();
  }
}

const WithLeaflet = withLeaflet(LeafletRuler);

export default connect((state) => ({
  rulerVisibility: state.map.rulerVisibility,
}))(WithLeaflet);
